/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Toggle_SidebarInputs */

const en_common_toggle_sidebar = /** @type {(inputs: Common_Toggle_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Sidebar`)
};

const es_common_toggle_sidebar = /** @type {(inputs: Common_Toggle_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar barra lateral`)
};

/**
* | output |
* | --- |
* | "Toggle Sidebar" |
*
* @param {Common_Toggle_SidebarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_toggle_sidebar = /** @type {((inputs?: Common_Toggle_SidebarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Toggle_SidebarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_toggle_sidebar(inputs)
	return es_common_toggle_sidebar(inputs)
});